import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Col, Row, Form } from "react-bootstrap";
import { Input, Select, Table, Pagination, PrintModal, Button } from "../../../../components";
import { paymentMethods, pass } from "../../../../constants";
import { convertPhone, jsonToXlsx, scrollToTop } from "../../../../methods";
import { axios, moment } from "../../../../boot";
import { toast } from "../../../../methods";
import PardakhtInfo from "../PardakhtInfo";

export default function ZarinPalPardakht() {
  const basicParams = JSON.parse(sessionStorage.getItem("params")) ?? {};

  const navigate = useNavigate();
  const [params, setParams] = useState({ page: 1, ...basicParams });
  const [purchases, setPurchases] = useState([]);
  const [pages, setPages] = useState({});
  const [modalInfo, setModalInfo] = useState(null)
  const [update, setUpdate] = useState(0)
  const [phone, setPhone] = useState("")

  const purchaseStatus = [
    {
      name: "تایید شده",
      id: "APPROVED",
      color: "success",
      isUpdateStatus: true,
      filterable: true,
    },
    {
      name: "رد شده",
      id: "REJECTED",
      color: "danger",
      filterable: true,
    },
    {
      name: "در انتظار تایید",
      id: "IN PROGRESS",
      color: "warning",
      filterable: true,
    },
  ]

  const saveParams = () => {
    const value = JSON.stringify(params);
    sessionStorage.setItem("params", value);
  };
  const getPurchases = (enter) => {
    saveParams();
    const url = "https://marveltradeconsult.com/api/payments/getAccountatntPayments";
    const config = {
      params: {
        userName: enter,
        pass,
        sort: "createdAt:-1",
        perPage: 20,
        paymentMethod: "IRR",
        ...params,
      },
    };
    params.date &&
      ([config.params.startDate, config.params.endDate] = params.date);
    delete config.params.date;
    config.params.phone && (config.params.phone = convertPhone(params.phone))
    axios.get(url, config).then(({ data }) => {
      setPurchases(data.data);
      setPages(data.pages);
      scrollToTop();
    });
  };
  const downloadXlsx = async () => {
    const url = "https://marveltradeconsult.com/api/payments/getAllAccountatntPayments"
    
    const config = {
      params: {
        userName: phone,
        pass,
      },
    };
    axios.get(url, config).then(async ({ data }) => {
      const allData = await Promise.all(data.data);
      const title = "report";
      const json = allData.flat().map((e, index) => ({
        "ردیف": `${index + 1}`,
        تاریخ: moment.miladiToShamsi({ date: e.createdAt }),
        خدمات: e.plan?.name,
        "نوع مشترک": "حقیقی",
        "کد ملی"  : `${e?.codeMelli ? e?.codeMelli : "" }`,
        "نام کاربر": `${e?.user?.firstName} ${e?.user?.lastName}`,
        // کدپستی: `${e.shipping?.postCode}`,
        "شماره موبایل": `${convertPhone(e.user?.phone)}`,
        "نوع پرداخت": paymentMethods.find((mt) => mt.id === "IRR")
          ?.name,
        قیمت: e.toomanAmount,
        "درصد تخفیف": e.discount > 0 ? e.discount : "بدون تخفیف",
        وضعیت: purchaseStatus.find((it) => it.id === e.status)?.name,
      }));
      jsonToXlsx({ json, title });
    });

  };


  const formControls = [
    {
      label: "تاریخ",
      state: "date",
      type: "date",
      cancelBtn: true,
    },
    {
      label: "نام",
      state: "firstName",
      type: "text",
      clear: true,
    },
    {
      label: "نام خانوادگی",
      state: "lastName",
      type: "text",
      clear: true,
    },
    {
      label: "شماره پیگیری",
      state: "refId",
      type: "number",
      clear: true,
    },
    {
      label: "شماره تلفن",
      state: "phone",
      type: "number",
      clear: true,
    },

    {
      tag: Select,
      label: "وضعیت",
      state: "status",
      cancelBtn: true,
      items: purchaseStatus.filter((e) => e.filterable),
    },
  ];
  const showStatus = (id = 0) => {
    const { color, name } = purchaseStatus.find((e) => e.id === id) ?? {};
    return <span className={`text-${color} fw-bold`}>{name}</span>;
  };

  useEffect(() => {
    const getPhone = JSON.parse(localStorage.getItem('phone'))
    setPhone(getPhone)
    getPurchases(getPhone)
  }, [params, update]);
  return (
    <React.Fragment>
      <PrintModal show={modalInfo != null} onHide={() => setModalInfo(null)} size="lg">
        <PardakhtInfo data={modalInfo} onUpdate={setUpdate} purchaseType="IRR" />
      </PrintModal>


      <div>
        <button
          className="bi bi-filetype-xlsx fs-3 text-success"
          onClick={downloadXlsx}
        />
      </div>
      <Row className="d-print-none">
        {formControls.map((e) => (
          <Col key={e.state} xs="12" md="6" lg="4">
            {React.createElement(e.tag ?? Input, {
              ...e,
              value: params[e.state],
              setValue: (val) => {
                setPurchases([]);
                setParams((p) => ({ ...p, page: 1, [e.state]: val }));
              },
            })}
          </Col>
        ))}
      </Row>

      <Table className="d-print-none">
        <thead>
          <tr>
            <th>شماره پیگیری</th>
            <th>نام خریدار</th>
            <th>شماره تلفن</th>
            <th>تاریخ</th>
            <th>مبلغ نهایی</th>
            <th>تخفیف</th>
            <th>نوع خدمت</th>
            <th>وضعیت</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {purchases?.map((e, i) => (

            <tr key={e._id + i}  >
              <td>{e?.refID ? e.refID : ""}</td>
              <td onClick={() => setModalInfo(e)}>
                {e?.user?.firstName} {e?.user?.lastName}
              </td>
              <td>0{e?.user?.phone}</td>
              <td onClick={() => setModalInfo(e)}>
                <span dir="ltr">
                  {moment.miladiToShamsi({
                    date: e.createdAt,
                    format: "jYYYY/jMM/jDD - HH:mm:ss",
                  })}
                </span>
              </td>
              <td onClick={() => setModalInfo(e)} className="text-success">{e.toomanAmount} تومان </td>
              <td onClick={() => setModalInfo(e)} className="text-danger">
                {e.discount > 0
                  ? `${e.discount} %`
                  : "بدون تخفیف"}
              </td>
              <td onClick={() => setModalInfo(e)} className="fw-bold">{e?.plan?.name}</td>
              <td onClick={() => setModalInfo(e)}>{showStatus(e.status)}</td>

            </tr>
          ))}
        </tbody>
      </Table>
      <Pagination
        totalPages={pages.totalPages}
        activePage={params.page}
        setActivePage={(page) => setParams((p) => ({ ...p, page }))}
      />
      {/* {params.page < pages.totalPages && (
        <button
          className="d-block mx-auto w-fit text-primary"
          onClick={() => {
            setParams((p) => ({ ...p, page: p.page + 1 }));
          }}
        >
          نمایش بیشتر...
        </button>
      )} */}
    </React.Fragment>
  );
}
